import Model, { attr, belongsTo } from '@ember-data/model';
import type Questionnaire from 'garaje/models/questionnaire';

export default class QuestionnaireResponse extends Model {
  @belongsTo('questionnaire', { async: false, inverse: null })
  declare questionnaire: Questionnaire;

  @attr('boolean') declare passed: boolean;
  @attr('number') declare score: number;
}
